export default {
    "2010": {
        "preface": "Literally moved out of my parents basement to another country.",
        "summary": "This year was a crazy year for both me and Inkling. I moved to another country and met the woman I would marry five years later, and Inkling went from being small to something pretty huge in a very short period of time.\n"
    },
    "2011": {
        "preface": "The year when we all learned that an engineer with less than a year of experience shouldn't be in charge of building a web store.",
        "summary": "As mentioned above, this year was huge in terms of personal learning experiences. While I did burn out pretty hard, I'm glad it happened while I was still so new to engineering.\n\nIt was also really cool seeing the start, and being a part, of both Habitat and Inkling for Web.\n"
    },
    "2012": {
        "preface": "Another year of 1.0's.",
        "summary": "2012 was a difficult year for me personally, but in looking back it was also one of my favorite years at Inkling. There was so much going on and it really seemed like the team was firing on all cylinders.\n"
    },
    "2013": {
        "preface": "Make or break for consumer."
    },
    "2014": {
        "preface": "The first pivot."
    },
    "2015": {
        "preface": "Hello married life, goodbye San Francisco.",
        "summary": "On top of iterating on our analytics products, this year we also started looking at how we could streamline and clean up the product as a whole. From here on out, most of my work at Inkling involved iterating on our existing products (until late 2016 to 2017).\n"
    },
    "2016": {
        "preface": "Living the dream in NYC."
    },
    "2017": {
        "preface": "So long farewell, auf wiedersehen, good bye.\n",
        "summary": "Like every year at Inkling, 2017 was full of change and a ton of hard work from everyone. I'm super grateful to have been a part of it.\n"
    }
};



// WEBPACK FOOTER //
// ./src/data/sections.js